// 后台配置路由，暂时先手写
import technology from '@/views/technology/technology.vue'

export const technologyRouterMap = [
  {
    path: '/technologyIndex',
    name: 'technologyIndex',
    meta: {
      moduleName: '稳稳当当新技术'
    },
    component: technology
  },
]



// WEBPACK FOOTER //
// ./src/router/technology.js